import React, { useEffect, useContext } from 'react';
import { Routes, Route } from 'react-router';
import Aos from 'aos';
import { LoadingContextProvider } from './components/LoadingContext';

import HeaderArea from './components/HeaderArea';
import FooterArea from './components/FooterArea';
import Home from './routes/Home';
import Services from './routes/Services';
import Registration from './routes/Registration';
import Training from './routes/Training';
import Privacy from './routes/Privacy';

const App = () => {

  useEffect(() => {
    Aos.init({
      delay: 200,
      duration: 1000
    });
  }, []);



  return (
    <LoadingContextProvider>
      <HeaderArea />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/services' element={< Services />} />
        <Route path='/training' element={< Training />} />
        <Route path='/privacy' element={< Privacy />} />
        <Route path='/register/:trainingId' element={< Registration />} />
      </Routes>
      <FooterArea />
    </LoadingContextProvider>
  );
}

export default App;